module.exports = __webpack_public_path__ + "assets/img/3_1226.4e86b2bd.jpg";